import { LoadingButton } from "@mui/lab";
import { Box, MenuItem, Select, TextField } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const AccessDeniedPage = () => {
  // const {
  //   data: roleList,
  //   isSuccess: isRoleListSuccess,
  //   isLoading: isRoleListLoading,
  // } = useGetAllRoleListQuery({});
  const navigate = useNavigate();
  const [accessToken, setaccessToken] = useState("");
  const [role, setRole] = useState("");
  const [roleList, setRoleList] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const handleSave = () => {
    if (role && accessToken) {
      localStorage.setItem("userRoleCode", role);
      localStorage.setItem("accessToken", accessToken);
      navigate("/");
    }
  };

  const getRoleList = async () => {
    setLoading(true);
    const res = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}/auth-mgmt/role-mgmt/roles`,
      {
        headers: {
          accessToken,
          "x-api-key": import.meta.env.VITE_AUTH_ROLE_API_KEY,
        },
      }
    );
    const data = await res.json();
    setRoleList(data?.data.decryptedData.items);
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
      }}
    >
      {
        <Box>
          <Box py={1}>
            You need access token to proceed. Please provide access token below.
          </Box>
          <Box
            component={"form"}
            onSubmit={(e) => {
              e.preventDefault();
              !role && getRoleList();
              handleSave();
            }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <TextField
              multiline
              fullWidth
              value={accessToken}
              onChange={(e) => setaccessToken(() => e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.shiftKey === false) {
                  getRoleList();
                }
              }}
              rows={3}
              id="snr-ai-accessDenied-accessToken"
            />
            {Array.isArray(roleList) && roleList.length ? (
              <>
                <Box py={1}>Please Select Role</Box>
                <Select
                  value={role}
                  onChange={(e) => setRole(() => e.target.value)}
                  id="snr-ai-accessDenied-roleSelect"
                >
                  {roleList.map((item: any) => (
                    <MenuItem
                      value={item.roleCode}
                      id={`snr-ai-accessDenied-roleItem-${item.roleCode}`}
                    >
                      {item.roleName}
                    </MenuItem>
                  ))}
                </Select>
              </>
            ) : null}
            <Box display={"flex"} justifyContent={"flex-end"} p={1}>
              <LoadingButton
                loading={loading}
                type={"submit"}
                variant="contained"
                id="snr-ai-accessDenied-saveButton"
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      }
    </Box>
  );
};
